"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var button_1 = tslib_1.__importDefault(require("../../button"));
var button_2 = require("../../button/button");
var ActionButton = function (props) {
    var clickedRef = React.useRef(false);
    var ref = React.useRef();
    var _a = tslib_1.__read(React.useState(false), 2), loading = _a[0], setLoading = _a[1];
    React.useEffect(function () {
        var timeoutId;
        if (props.autoFocus) {
            var $this_1 = ref.current;
            timeoutId = setTimeout(function () { return $this_1.focus(); });
        }
        return function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, []);
    var handlePromiseOnOk = function (returnValueOfOnOk) {
        var closeModal = props.closeModal;
        if (!returnValueOfOnOk || !returnValueOfOnOk.then) {
            return;
        }
        setLoading(true);
        returnValueOfOnOk.then(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
            // setState({ loading: false });
            closeModal.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
        }, function (e) {
            // Emit error when catch promise reject
            // eslint-disable-next-line no-console
            console.error(e);
            setLoading(false);
            clickedRef.current = false;
        });
    };
    var onClick = function () {
        var actionFn = props.actionFn, closeModal = props.closeModal;
        if (clickedRef.current) {
            return;
        }
        clickedRef.current = true;
        if (!actionFn) {
            closeModal();
            return;
        }
        var returnValueOfOnOk;
        if (actionFn.length) {
            returnValueOfOnOk = actionFn(closeModal);
            clickedRef.current = false;
        }
        else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                closeModal();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    var type = props.type, children = props.children, prefixCls = props.prefixCls, buttonProps = props.buttonProps, _b = props.danger, danger = _b === void 0 ? false : _b;
    return (React.createElement(button_1.default, tslib_1.__assign({ danger: danger }, (0, button_2.convertLegacyProps)(type), { onClick: onClick, loading: loading, prefixCls: prefixCls }, buttonProps, { ref: ref }), children));
};
exports.default = ActionButton;
//# sourceMappingURL=ActionButton.js.map